module.exports = __webpack_public_path__ + "img/MFT白皮书_5.32226048.jpg";